import Axios from "@/request/config";
import {ElMessage} from "element-plus";

export function postRequest(url, data, callback, failCallback, errorCallback) {
    sendRequest(url, data, "post", null, callback, failCallback, errorCallback)
}

export function postRequestCustomHeaders(url, data, headers, callback, failCallback, errorCallback) {
    sendRequest(url, data, "post", headers, callback, failCallback, errorCallback)
}

export function getRequest(url, data, callback, failCallback, errorCallback) {
    sendRequest(url, data, "get", null, callback, failCallback, errorCallback)
}

export function getRequestCustomHeaders(url, data, headers, callback, failCallback, errorCallback) {
    sendRequest(url, data, "get", headers, callback, failCallback, errorCallback)
}

function sendRequest(url, data, type, headers, callback, failCallback, errorCallback) {
    const header = {
        headers: {'Content-Type': 'application/json'}
    }

    if (null != headers && typeof headers === "object"){
        for (let key in headers){
            if (headers.hasOwnProperty(key)){
                header.headers[key] = headers[key]
            }
        }
    }


    Axios[type](url, data, headers).then(res => {
        if (null != callback && typeof callback === "function"){
            callback(res)
        }else{
            if (res.code == "200"){
                defaultSuccessFunc(res)
            }else{
                defaultFailFunc(res)
            }
        }
    }).catch(err => {
        if (process.env.NODE_ENV !== 'production'){
            console.log("-------------------- error -----------------------------")
            console.log(url)
            console.log(err)
            console.log("-------------------- error -----------------------------")
        }

        if (null != errorCallback && typeof errorCallback === "function"){
            errorCallback(err)
        }else{
            defaultErrorFunc()
        }
    });
}

function defaultSuccessFunc() {
    ElMessage({
        showClose: true,
        message: '操作成功',
        type: 'success',
        offset: 180
    })
}

function defaultFailFunc(res) {
    ElMessage({
        showClose: true,
        message: res.msg == null ? "數據異常" : res.msg,
        type: 'warning',
        offset: 180
    })
}

function defaultErrorFunc(res) {
    ElMessage({
        showClose: true,
        message: "網絡異常",
        type: 'error',
        offset: 180
    })
}
